//highest first
export default 
{
    EnlargedImageArea: 10001,
    Navbar: 10000,
    hideTimelineText: 400,
    BlackBackground: 0,
}